import { render, staticRenderFns } from "./partnerinfo.vue?vue&type=template&id=7225a881&scoped=true"
import script from "./partnerinfo.vue?vue&type=script&lang=js"
export * from "./partnerinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225a881",
  null
  
)

export default component.exports